import { Stack } from "@mui/material";
import React from "react";

const OptionContainer = ({ children, ...props }) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      bgcolor={"#1F2937"}
      border={"1px solid #4B5563"}
      padding={"0.25rem"}
      borderRadius={"0.5rem"}
      width={"fit-content"}
      {...props}
    >
      {children}
    </Stack>
  );
};

export default OptionContainer;
